import React from 'react';
import { Link } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import { LEGAL_DETAILS } from '../config/legal';
import { useI18n } from '../i18n/I18nContext';
import { getLegalCopy } from '../i18n/legalCopy';
import '../style/Homepage.css';

const SharingSettings = () => {
  const { language } = useI18n();
  const copy = getLegalCopy(language);
  const page = copy.sharing;

  return (
    <div>
      <Header />
      <main className="info-page terms-page sharing-settings-page">
        <section className="info-hero terms-hero">
          <p className="eyebrow">{page.eyebrow}</p>
          <h1>{page.title}</h1>
          <p>{copy.updated} {page.intro}</p>
          <div className="hero-actions">
            <Link to="/contact?topic=privacy" className="primary-button">{page.delete}</Link>
            <Link to="/privacy" className="secondary-button">{copy.common.privacy}</Link>
            <Link to="/account-and-google-privacy" className="secondary-button">{page.google}</Link>
          </div>
        </section>

        <section className="feature-grid info-grid terms-summary-grid" aria-label={page.summaryLabel}>
          {page.cards.map(([title, body]) => (
            <article className="feature-card" key={title}><h3>{title}</h3><p>{body}</p></article>
          ))}
        </section>

        <section className="terms-notice">
          <div><p className="eyebrow">{page.noticeEyebrow}</p><h2>{page.noticeTitle}</h2></div>
          <p>{page.noticeBody}</p>
        </section>

        <section className="terms-content" aria-label={page.detailsLabel}>
          {page.sections.map(([title, paragraphs]) => (
            <article className="terms-section-card" key={title}>
              <h2>{title}</h2>
              <div>{paragraphs.map((paragraph) => <p key={paragraph}>{paragraph}</p>)}</div>
            </article>
          ))}
        </section>

        <section className="terms-contact-card sharing-settings-contact-card">
          <div><p className="eyebrow">{page.helpEyebrow}</p><h2>{page.helpTitle}</h2></div>
          <p>{page.helpBody} <Link to="/contact?topic=privacy">{copy.common.contact}</Link>. {LEGAL_DETAILS.privacyEmail}</p>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default SharingSettings;
